import { render, staticRenderFns } from "./TaxiBankAccountCard.vue?vue&type=template&id=af410bf4&scoped=true"
import script from "./TaxiBankAccountCard.vue?vue&type=script&lang=js"
export * from "./TaxiBankAccountCard.vue?vue&type=script&lang=js"
import style0 from "./TaxiBankAccountCard.vue?vue&type=style&index=0&id=af410bf4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af410bf4",
  null
  
)

export default component.exports